module.exports = __webpack_public_path__ + "static/header-image-b7c05c5384d69475f45c38dd0cbaf2bc.png";